const SLIDERS = {
	fourth: {
		title: ['Reimagine Cloud', 'and Big Data Innovations'],
		text: ['with the domain and technology experts']
	},
	first: {
		title: ['Migrate to the cloud with a preferred', 'vendor for Google Data Fusion'],
		text: ['Transfer your infrastructure, enterprise applications, or data', 'to the cloud in a fast, reliable, and cost-effective way']
	},
	second: {
		title: ['Enterprise on-prem support', 'for CDAP from expert contributors'],
		text: ['Effortless on-premise and cloud deployment', 'of the end-to-end data ingestion system']
	},
	third: {
		title: ['Full-stack Hadoop and', 'Data Analytics solutions'],
		text: ['We can help you grow your business through intelligent data', 'pipelines management, focusing on system as a whole']
	}
};

export default SLIDERS;
